export default {
  user: {},
  token: '',
  email: '',
  password: '',
  process: false,
  successMessage: false,
  errorMessage: false,
  isAdmin: false,
  isTeacher: false,
  isEditor: false,
  DialodPermissionDenied: false,
}
